<p class="mb-2">
    <img src="assets/img/ic_help.svg" /> Address Details
    <span>
        <button type="button" class="bg-main2 btn-add-1">
            <i (click)="addAddress('#zero_add_address','Add Address')" class="fa fa-plus"></i>
        </button>
    </span>
</p>
<div class="bg-white p-3 shadow-main border-up-down">
    <div class="row">
        <div class="col-md-6">
            <table class="font-weight-normal w-100">
                <tr *ngFor="let dat of myAddress">
                    <td *ngIf="dat.is_primary == 1">
                        <a class="name">
                            <b>{{dat.add_person_name}}</b>
                            <div class="edit-icon" *ngIf="config.delete">
                                <i (click)="deleteAddress(dat.add_id)" class="fa fa-trash-o"></i>
                            </div>
                            <div class="edit-icon">
                                <i (click)="editAddress(dat.add_id,'Edit Address')" class="fa fa-pencil"></i>
                            </div>
                        </a>
                        <br> {{dat.add_line1}} {{dat.add_line2}} {{dat.add_line3}}
                        <br> {{dat.ct_name}} <b>{{dat.st_name}}</b> <b>{{dat.pincode_id}}</b>
                        <br>
                        <span *ngIf="dat.is_primary == 1" class="btn-success btnspandark">Primary</span>
                        <!-- <span *ngIf="dat.is_secondary == 1" class="btn-warning text-white btnspandark">Secondary</span> -->
                    </td>
                </tr>
            </table>
        </div>
        <div class="col-md-6 border-left">
            <table class="font-weight-normal w-100">
                <tr *ngFor="let dat of myAddress">
                    <td *ngIf="dat.is_secondary == 1">
                        <a class="name">
                            <b>{{dat.add_person_name}}</b>
                            <div class="edit-icon" *ngIf="config.delete">
                                <i (click)="deleteAddress(dat.add_id)" class="fa fa-trash-o"></i>
                            </div>
                            <div class="edit-icon">
                                <i (click)="editAddress(dat.add_id,'Edit Address')" class="fa fa-pencil"></i>
                            </div>
                        </a>
                        <br> {{dat.add_line1}} {{dat.add_line2}} {{dat.add_line3}}
                        <br> {{dat.ct_name}} <b>{{dat.st_name}}</b> <b>{{dat.pincode_id}}</b>
                        <br>
                        <span *ngIf="dat.is_secondary == 1" class="btn-warning text-white btnspandark">Secondary</span>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</div>

<!-- Address Modal -->
<div id="zero_add_address" class="modal  custom-modal fade" data-backdrop="static" role="dialog">
  <div class="modal-dialog   modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title" id="zero_country_form_title"> {{dynamicHeader}}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
          </div>

          <form [formGroup]="addressForm" (ngSubmit)="onSubmitAddress()" id="zero_country_form" class="horizontal-form" name="zero_country_form" method="post" enctype="multipart/form-data">
              <div class="modal-body">
                  <div class="row">
                      <div class="col-md-6">
                          <div class="form-group">
                              <label for="country_name">Contact Name<span class="text-danger">*</span></label>
                              <input class="form-control" id="country_name" type="text" formControlName="person_name">
                              <div *ngIf="subAdd && addErrorMsg.person_name.errors" class="form-error">
                                  <div *ngIf="addErrorMsg.person_name.errors.required">Contact Name is required !</div>
                              </div>
                          </div>
                      </div>
                      <div class="col-md-6">
                          <div class="form-group">
                              <label for="curr">Address Line 1<span class="text-danger">*</span></label>
                              <input class="form-control" type="text" formControlName="addline_1">
                              <div *ngIf="subAdd && addErrorMsg.addline_1.errors" class="form-error">
                                  <div *ngIf="addErrorMsg.addline_1.errors.required">Address is required !</div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-md-6">
                          <div class="form-group">
                              <label for="curr">Address Line 2</label>
                              <input class="form-control" type="text" formControlName="addline_2">
                              <div *ngIf="subAdd && addErrorMsg.addline_2.errors" class="form-error">
                                  <div *ngIf="addErrorMsg.addline_2.errors.required">Address II is required !</div>
                              </div>
                          </div>
                      </div>
                      <div class="col-md-6">
                          <div class="form-group">
                              <label for="curr">Address Line 3</label>
                              <input class="form-control" type="text" formControlName="addline_3">
                              <div *ngIf="subAdd && addErrorMsg.addline_3.errors" class="form-error">
                                  <div *ngIf="addErrorMsg.addline_3.errors.required">Address III is required !</div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-md-6">
                          <div class="form-group">
                              <label for="iso_code">Country<span class="text-danger">*</span></label>
                              <select2 [data]="country" value="value" formControlName="cn_id" placeholder="Select Country" (update)="onChangeCountry($event)"></select2>
                              <!-- <select class="form-control" id="timezone" formControlName="cn_id" (change)="onChangeCountry($event)">
                                  <option value="">--Select--</option>
                                  <option value={{dat.cn_id}} *ngFor="let dat of country">{{dat.cn_name}}</option>
                              </select> -->
                              <div *ngIf="subAdd && addErrorMsg.cn_id.errors" class="form-error">
                                  <div *ngIf="addErrorMsg.cn_id.errors.required">Country required !</div>
                              </div>
                          </div>
                      </div>
                      <div class="col-md-6">
                          <div class="form-group">
                              <label for="lang">State<span class="text-danger">*</span></label>
                              <select2 [data]="myState" value="value" placeholder="Select State" formControlName="st_id" (update)="onChangeState($event)"></select2>
                              <!-- <select class="form-control" id="lang" formControlName="st_id" (change)="onChangeState($event)">
                                  <option value="">--Select--</option>
                                  <option value="{{val.st_id}}" *ngFor="let val of myState">{{val.st_name}} - {{val.st_id}}</option>
                              </select> -->
                              <div *ngIf="subAdd && addErrorMsg.st_id.errors" class="form-error">
                                  <div *ngIf="addErrorMsg.st_id.errors.required">State is required !</div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <!-- <div class="row">
                      <div class="col-md-6">
                          <div class="form-group">
                              <label for="iso_code">Region<span class="text-danger">*</span></label>
                              <select class="form-control" id="timezone" formControlName="rgn_id">
                                  <option value="">--Select--</option>
                                  <option value={{dat.rgn_id}} *ngFor="let dat of myRegion">{{dat.rgn_name}}</option>
                              </select>
                              <div *ngIf="subAdd && addErrorMsg.rgn_id.errors" class="form-error">
                                  <div *ngIf="addErrorMsg.rgn_id.errors.required">Region required !</div>
                              </div>
                          </div>
                      </div>
                      <div class="col-md-6">
                          <div class="form-group">
                              <label for="curr">Division<span class="text-danger">*</span></label>
                              <select class="form-control" id="curr" formControlName="dvsn_id">
                                  <option value="">--Select--</option>
                                  <option *ngFor="let dat of myDivision" value="{{dat.dvsn_id}}">{{dat.dvsn_name}}</option>
                              </select>
                              <div *ngIf="subAdd && addErrorMsg.dvsn_id.errors" class="form-error">
                                  <div *ngIf="addErrorMsg.dvsn_id.errors.required">Division is required !</div>
                              </div>
                          </div>
                      </div>
                  </div> -->

                  <div class="row">
                      <div class="col-md-6">
                          <div class="form-group">
                              <label for="lang">City<span class="text-danger">*</span></label>
                              <select2 [data]="myCity" value="value" placeholder="Select City" formControlName="city_id"></select2>
                              <!-- <select class="form-control" id="curr" formControlName="city_id" (change)="onChangeCity($event)">
                                  <option value="">--Select--</option>
                                  <option *ngFor="let inds of myCity" value="{{inds.ct_id}}">{{inds.ct_name}}</option>
                              </select> -->
                              <div *ngIf="subAdd && addErrorMsg.city_id.errors" class="form-error">
                                  <div *ngIf="addErrorMsg.city_id.errors.required">City is required !</div>
                              </div>
                          </div>
                      </div>
                      <div class="col-md-6">
                          <div class="form-group">
                              <label for="curr">Pincode<span class="text-danger">*</span></label>
                              <input type="number" class="form-control" formControlName="pincode" />
                              <div *ngIf="subAdd && addErrorMsg.pincode.errors" class="form-error">
                                  <div *ngIf="addErrorMsg.pincode.errors.required">Pincode is required !</div>
                              </div>
                          </div>
                      </div>

                  </div>
                  <div class="row">
                      <div class="col-md-6">
                          <div class="form-group">
                              <label for="curr">Address Type<span class="text-danger">*</span></label>
                              <select class="form-control" formControlName="isPrimary">
                                  <option value="1">Permanent</option>
                                  <option value="0">Temporary</option>
                              </select>
                              <div *ngIf="subAdd && addErrorMsg.isPrimary.errors" class="form-error">
                                  <div *ngIf="addErrorMsg.isPrimary.errors.required">Address trype is required !</div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="modal-footer">
                  <button type="submit" [disabled]="loading" class="btn btn-primary btn-sm "><span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span><i class="fa fa-save"></i> SAVE</button>
                  <button type="button" class="btn btn-danger btn-sm" (click)="onResetaddress()" data-dismiss="modal">Close</button>
              </div>
          </form>
      </div>
  </div>
</div>
